import { render, staticRenderFns } from "./LuckDraw.vue?vue&type=template&id=557e5a81&scoped=true&"
import script from "./LuckDraw.vue?vue&type=script&lang=js&"
export * from "./LuckDraw.vue?vue&type=script&lang=js&"
import style0 from "./LuckDraw.vue?vue&type=style&index=0&id=557e5a81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557e5a81",
  null
  
)

export default component.exports